import React, { useState } from "react";
import useFetch from "../../hooks/useFetch";

const Slider = () => {
  const { data, loading, error } = useFetch(`/banners?populate=*`, 'NoToken');
  
  return (
    error
    ? "Something went wrong!"
    : loading
    ? "loading"
    :
      <div id="template-mo-zay-hero-carousel" className="carousel slide" data-bs-ride="carousel">
        <ol className="carousel-indicators slider-nav-color">
          {data?.map((item) =>
          <li data-bs-target="#template-mo-zay-hero-carousel slider-nav-color" key={item.id} data-bs-slide-to="{item.id}" className={item.id == "0" ? "active" : ""}></li>
          )}
        </ol>
        <div className="carousel-inner">
          {data?.map((item, idx) => 
            <div className={idx === 0 ? "carousel-item active" : "carousel-item"} key={item.id}>
              <div className="container">
                {(item.banner_url) ? <a href={item.banner_url}>
                  <img className="img-fluid" src={process.env.REACT_APP_UPLOAD_URL + item.banner_image} alt=""></img>
                </a> : <img className="img-fluid" src={process.env.REACT_APP_UPLOAD_URL + item.banner_image} alt=""></img>}
                <div className="align-items-center position-absolute title-text">
                  <div className="text-align-left align-self-center">
                    <h3 className="h2 text-success">{item.banner_subtitle}</h3>
                    <p>{item.banner_description}</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <a className="carousel-control-prev text-decoration-none w-auto ps-3" href="#template-mo-zay-hero-carousel" role="button" data-bs-slide="prev">
            <i className="fas fa-chevron-left slider-nav-color"></i>
        </a>
        <a className="carousel-control-next text-decoration-none w-auto pe-3" href="#template-mo-zay-hero-carousel" role="button" data-bs-slide="next">
            <i className="fas fa-chevron-right slider-nav-color"></i>
        </a>
      </div>
  );
};

export default Slider;